import type { ResumeDto } from "@stackmorph/dto";
import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";

export const shareResumeWithOrganization = async (data: { id: string; organizationId: string }) => {
  const response = await axios.patch<ResumeDto, AxiosResponse<ResumeDto>>(
    `/resume/${data.id}/share`,
    { organizationId: data.organizationId },
  );

  // Update cache
  queryClient.setQueryData<ResumeDto>(["resume", { id: response.data.id }], response.data);

  queryClient.setQueryData<ResumeDto[]>(["resumes"], (cache) => {
    if (!cache) return [response.data];
    return cache.map((resume) => {
      if (resume.id === response.data.id) return response.data;
      return resume;
    });
  });

  return response.data;
};

export const removeResumeFromOrganization = async (data: { id: string }) => {
  const response = await axios.delete<ResumeDto>(`/resume/${data.id}/share`);

  // Update cache
  queryClient.setQueryData<ResumeDto>(["resume", { id: response.data.id }], response.data);

  queryClient.setQueryData<ResumeDto[]>(["resumes"], (cache) => {
    if (!cache) return [response.data];
    return cache.map((resume) => {
      if (resume.id === response.data.id) return response.data;
      return resume;
    });
  });

  return response.data;
};

export const useShareResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: shareResumeFn,
  } = useMutation({
    mutationFn: shareResumeWithOrganization,
  });

  return { shareResume: shareResumeFn, loading, error };
};

export const useRemoveResumeShare = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: removeShareFn,
  } = useMutation({
    mutationFn: removeResumeFromOrganization,
  });

  return { removeShare: removeShareFn, loading, error };
};
